import { createStore } from "vuex";
import landing from "./modules/landing";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    landing,
  },
});
